<!--begin::Content-->
<div class="content d-flex flex-column flex-column-fluid" id="kt_content">
  <!--begin::Container-->
  <div class="container-xxl" id="kt_content_container">
    <!--begin::Card-->
    <div class="card">
      <!--begin::Card header-->
      <div class="card-header border-0 pt-6">
        <!--begin::Card title-->
        <div class="card-title">
          <h2 class="fw-bold">Update Profile</h2>
        </div>
        <!--end::Card title-->
      </div>
      <!--end::Card header-->

      <!--begin::Card body-->
      <div class="card-body pt-0">
        <!--begin::Form-->
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" id="kt_profile_form" class="form">
          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label fw-semibold fs-6">
              <span class="required">Title</span>
            </label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <select formControlName="title" class="form-select form-select-solid"
                      [class.is-invalid]="isFieldInvalid('title')">
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('title')">
                {{ getFieldError('title') }}
              </div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label required fw-semibold fs-6">Full Name</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="text" formControlName="name" class="form-control form-control-lg form-control-solid"
                     placeholder="Enter full name" [class.is-invalid]="isFieldInvalid('name')" />
              <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                {{ getFieldError('name') }}
              </div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label required fw-semibold fs-6">Login ID</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="text" formControlName="login_id" class="form-control form-control-lg form-control-solid bg-light"
                     placeholder="Login ID" readonly />
              <div class="form-text text-muted">Login ID cannot be changed</div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label required fw-semibold fs-6">Email</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="email" formControlName="email" class="form-control form-control-lg form-control-solid bg-light"
                     placeholder="Email address" readonly />
              <div class="form-text text-muted">Email cannot be changed</div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label required fw-semibold fs-6">Phone</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="text" formControlName="phone" class="form-control form-control-lg form-control-solid"
                     placeholder="Enter phone number" [class.is-invalid]="isFieldInvalid('phone')" />
              <div class="invalid-feedback" *ngIf="isFieldInvalid('phone')">
                {{ getFieldError('phone') }}
              </div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label fw-semibold fs-6">Password</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="password" formControlName="password" class="form-control form-control-lg form-control-solid"
                     placeholder="Leave empty to keep current password, or enter new password to update"
                     autocomplete="new-password" />
              <div class="form-text text-muted">Enter a new password only if you want to update it</div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Row-->
          <div class="row mb-6">
            <!--begin::Label-->
            <label class="col-lg-3 col-form-label fw-semibold fs-6">Confirm Password</label>
            <!--end::Label-->

            <!--begin::Col-->
            <div class="col-lg-9 fv-row">
              <input type="password" formControlName="confirm_password" class="form-control form-control-lg form-control-solid"
                     placeholder="Re-enter new password"
                     [class.is-invalid]="hasPasswordMismatch()"
                     autocomplete="new-password" />
              <div class="invalid-feedback" *ngIf="hasPasswordMismatch()">
                Passwords do not match
              </div>
            </div>
            <!--end::Col-->
          </div>
          <!--end::Row-->

          <!--begin::Actions-->
          <div class="row">
            <div class="col-lg-9 offset-lg-3">
              <button type="submit" class="btn btn-primary indicator me-3"
                      style="min-width: 150px; height: 44px;"
                      [disabled]="isLoading">
                <!--begin::Indicator label-->
                <span class="indicator-label" *ngIf="!isLoading">Update Profile</span>
                <!--end::Indicator label-->
                <!--begin::Indicator progress-->
                <span class="indicator-progress" *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                  Please wait...
                </span>
                <!--end::Indicator progress-->
              </button>
              <button type="button" class="btn btn-secondary" (click)="resetForm()" [disabled]="isLoading">
                Reset
              </button>
            </div>
          </div>
          <!--end::Actions-->
        </form>
        <!--end::Form-->
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Card-->
  </div>
  <!--end::Container-->
</div>
<!--end::Content-->
